import { HomeRouterLayout } from "@spa/app/layouts/HomeRouterLayout";
import { withSuspense } from "@spa/app/routes/withSuspense";
import type { RouteObject } from "react-router-dom";

const HomePage = withSuspense(
  () => import("@dust-tt/front/components/pages/home/HomePage"),
  "HomePage"
);

// Home is the workspace landing route. `/w/:wId/home` is the addressable form;
// the workspace index renders the same page so a bare workspace URL lands here.
export const homeRoutes: RouteObject[] = [
  {
    element: <HomeRouterLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "home", element: <HomePage /> },
    ],
  },
];
